const MINUTE_SECONDS = 60;
const HOUR_SECONDS = 3600;

/**
 * A job run's `results.durationSeconds` as `4.2s`, `42s`, `1m 36s` or `2h 5m`.
 * Runs recorded before durations were tracked have none and show `—`.
 */
export const formatRunDuration = (seconds: unknown): string => {
  if (typeof seconds !== 'number') return '—';
  if (seconds < 10) return `${seconds.toFixed(1)}s`;
  const total = Math.round(seconds);
  if (total < MINUTE_SECONDS) return `${total}s`;
  const hours = Math.floor(total / HOUR_SECONDS);
  const minutes = Math.floor((total % HOUR_SECONDS) / MINUTE_SECONDS);
  return hours ? `${hours}h ${minutes}m` : `${minutes}m ${total % MINUTE_SECONDS}s`;
};
